/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregationResultDto } from '../../models/aggregation-result-dto';

export interface DashboardMachineClassificationsByDayGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardMachineClassificationsByDayGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardMachineClassificationsByDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardMachineClassificationsByDayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AggregationResultDto>>;
    })
  );
}

dashboardMachineClassificationsByDayGet$Plain.PATH = '/Dashboard/machine-classifications-by-day';
